/**
 * Percent of one rank requirement met, 0-100. A requirement with no bar
 * (`need <= 0`) counts as met; over-achievement is capped at 100.
 */
export function requirementPct(have: number, need: number): number {
  if (!Number.isFinite(need) || need <= 0) return 100;
  if (!Number.isFinite(have)) return 0;
  return Math.max(0, Math.min(100, (have / need) * 100));
}

/**
 * The single "NN% to <next rank>" figure on the rank tracker: the mean of the
 * VISIBLE requirements' percentages (the caller passes the list after the
 * `need > 0` and `trackerHidden` filter, so the number always agrees with the
 * bars a member can see). Floored, so it reads 100 only when every visible bar
 * is met. Null when nothing is visible, so the caller renders no figure.
 */
export function overallRankProgressPct(
  reqs: ReadonlyArray<{ have: number; need: number }>,
): number | null {
  if (reqs.length === 0) return null;
  const sum = reqs.reduce((acc, r) => acc + requirementPct(r.have, r.need), 0);
  return Math.floor(sum / reqs.length);
}
